import { render } from "./SocialPost.vue?vue&type=template&id=e0f1fede&scoped=true"
import script from "./SocialPost.vue?vue&type=script&lang=js"
export * from "./SocialPost.vue?vue&type=script&lang=js"

import "./SocialPost.vue?vue&type=style&index=0&id=e0f1fede&lang=scss"
import "./SocialPost.vue?vue&type=style&index=1&id=e0f1fede&lang=scss&scoped=true"
import "./SocialPost.vue?vue&type=style&index=2&id=e0f1fede&lang=scss"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0f1fede"]])

export default __exports__